<template>
  <div class="p-20 border-r16 shadow-1 bg-white mt-20">
    <div id="myChartMap">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import "../../../../node_modules/echarts/map/js/world.js";
export default {
  name: "DataMap",
  props: { msg: Array },
  data() {
    return {
      mapdata: [],
      labelShow: true,
    };
  },
  watch: {
    msg() {
      // 传值监听，值变化了才渲染页面

      //   let self = this;
      this.drawMap();
    },
  },
  mounted() {
    this.drawMap();
  },
  methods: {
    drawMap() {
      let self = this;
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 992) {
        self.labelShow = false;
      }
      // 基于准备好的dom，初始化echarts实例
      let myChartMap = this.$echarts.init(
        document.getElementById("myChartMap")
      );
      // 绘制图表
      myChartMap.setOption({
        tooltip: {
          formatter: function(params) {
            return "企业数量" + "<br />" + params.name + "：" + params.value;
          },
          // 鼠标悬浮的 提示框 数据格式化
        },
        visualMap: {
          min: 0,
          max: 1000,
          left: "left",
          top: "bottom",
          text: ["高", "低"], //取值范围的文字
          inRange: {
            color: ["#fff", "#a1a1a1"], //取值范围的颜色
          },
          show: true, //图注
        },
        geo: {
          map: "world",
          roam: false, //不开启缩放和平移
          zoom: 1.23, //视角缩放比例
          label: {
            normal: {
              show: false,
              fontSize: "10",
              color: "rgba(0,0,0,0.7)",
            },
          },
          itemStyle: {
            normal: {
              borderColor: "rgba(0, 0, 0, 0.2)",
            },
            emphasis: {
              areaColor: "#eeeeee", //鼠标选择区域颜色 目前是个黄色，改色值即可
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              shadowBlur: 20,
              borderWidth: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },

        series: [
          {
            name: "项目分布",
            type: "map",
            geoIndex: 0,
            data: self.mapdata,
          },
        ],
      });
      window.addEventListener("resize", function() {
        myChartMap.resize();
      });
    },
  },
};
</script>

<style scoped>
#myChartMap {
  width: 100%;
  height: 641px;
}

@media screen and (max-width: 992px) {
  #myChartMap {
    height: 341px;
  }
}
</style>
